module.exports = __webpack_public_path__ + "img/tu01.b6d6b2f3.png";